import {Image} from '@/_application/core/components/ui/image';
import ProductLoader from '@/_application/core/components/ui/loaders/product-loader';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import {useInterestedProducts} from '@/framework/product';
import rangeMap from '@/lib/range-map';
import {useTranslation} from 'next-i18next';
import {LazyLoadBlock} from '@/_application/core/components/commons/lazy-load-block';
import {useCallback, useMemo} from 'react';
import {ProductInterface} from '@/__generated__/__types__';

const LoveCircle = getImageAssetUrl('icons/love-circle.png');

const RecommendedProductBlock = () => {
    const {t} = useTranslation('common');
    const {data, isLoading} = useInterestedProducts();

    const productList = useMemo(() => {
        return (data?.items?.filter(item => item !== null) ?? []) as ProductInterface[];
    }, [data?.items]);

    const renderProductList = useCallback(() => {
        return productList?.map(product => (
            <LazyLoadBlock key={product?.sku} isLazyLoad={true}>
                <ProductCard product={product} className="" />
            </LazyLoadBlock>
        ));
    }, [productList]);

    return (
        <div className="w-full bg-white">
            <div className="flex h-10 content-center items-center justify-start bg-KPZ_Blue-Dark py-2 pl-4">
                <Image src={LoveCircle} alt="love-circle" height={34} width={34} />
                <p className="ml-4 text-base font-bold text-white">
                    {t('for-you-products', 'Sản phẩm dành riêng cho bạn')}
                </p>
            </div>

            <div className="mx-4 py-6">
                <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
                    {isLoading
                        ? rangeMap(6, i => <ProductLoader key={i} uniqueKey={`product-${i}`} />)
                        : renderProductList()}
                </div>
            </div>
        </div>
    );
};

export default RecommendedProductBlock;
